import { configure } from 'mobx';
import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga';
import axiosConfig from '@configs/axiosConfig';
import { initialize } from '@configs/firebase';
import i18nInit from '@translations/i18ninit';
import { gtmId, gaTrackingId } from './configs/variables';

export default (): void => {
  configure({ enforceActions: 'observed' });

  i18nInit();
  axiosConfig();
  initialize();

  TagManager.initialize({
    gtmId,
  });

  ReactGA.initialize(gaTrackingId);
};
